import { Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { formatarCPFCNPJ, permitirApenasNumeros } from "../../../../../../../helpers/masks";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectBancos from "../../../../../../../components/SelectsSimpleApiQuery/SelectBancos";

export default function Step01() {

  const { getValues, control, handleSubmit, setValue } = useFormContext()

  const handleNext = getValues('funcoesAux.onNext')

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.publico"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectPublico
                {...field}
                error={invalid}
                required
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => {
                  field.onChange(valor)
                  if (valor && valor.conta_cheque) {
                    const contaCheque = valor.conta_cheque
                    setValue('step01.banco', contaCheque.banco)
                    setValue('step01.agencia', contaCheque.agencia)
                    setValue('step01.conta', contaCheque.conta)
                    setValue('step01.conta_digito', contaCheque.conta_digito)
                    setValue('step02.praca', contaCheque.cidade)
                  }
                  setValue('step01.documento', valor ? formatarCPFCNPJ(valor.documento_pessoa) : '')
                }}
                extraParams={{ retornar_cheque_contas: true }}
              />
            )
          }}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.documento"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="CPF/CNPJ"
              value={field.value}
              slotProps={{ htmlInput: { maxLength: 16 } }}
              onChange={(valor) => {
                const newValue = formatarCPFCNPJ(valor.target.value);
                field.onChange(newValue)
              }
              }
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.banco"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectBancos
                {...field}
                error={invalid}
                required
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => { field.onChange(valor) }}
              />
            )
          }}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.numero_cheque"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Número Cheque"
              slotProps={{ htmlInput: { maxLength: 10 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = permitirApenasNumeros(valor.target.value);
                field.onChange(newValue)
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.sequencia_cheque"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Sequência cheque"
              slotProps={{ htmlInput: { maxLength: 3 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = permitirApenasNumeros(valor.target.value);
                field.onChange(newValue)
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.agencia"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Agência"
              slotProps={{ htmlInput: { maxLength: 5 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = permitirApenasNumeros(valor.target.value);
                field.onChange(newValue)
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.agencia_digito"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="Agência dígito"
              slotProps={{ htmlInput: { maxLength: 1 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = (valor.target.value);
                field.onChange(newValue)
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.conta"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Conta"
              slotProps={{ htmlInput: { maxLength: 12 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = permitirApenasNumeros(valor.target.value);
                field.onChange(newValue)
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <Controller
          name="step01.conta_digito"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Conta dígito"
              slotProps={{ htmlInput: { maxLength: 1 } }}
              value={field.value}
              onChange={(valor) => {
                const newValue = (valor.target.value);
                field.onChange(newValue)
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleNext)}
        >
          Avançar
        </Button>
      </Grid>
    </Grid>
  )
}
